import { useState, useEffect, useCallback } from 'react';
import ReportsService from '@/services/reportsService';

export default function useCategorySales() {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({
    totalCategories: 0,
    totalItems: 0,
    totalQuantity: 0,
    totalNetSales: 0,
  });
  const [branchSummary, setBranchSummary] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    period: 'today',
    startDate: null,
    endDate: null,
    offset: 0,
    limit: 25,
    sortColumn: 'net_sales',
    sortDirection: 'DESC',
  });

  const fetchCategorySales = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        offset: filters.offset,
        limit: filters.limit,
        sortColumn: filters.sortColumn,
        sortDirection: filters.sortDirection,
      };

      if (filters.branchId) params.branchId = filters.branchId;

      if (filters.period) {
        params.period = filters.period;
      }

      if (!filters.period && filters.startDate && filters.endDate) {
        params.startDate = filters.startDate;
        params.endDate = filters.endDate;
      }

      const res = await ReportsService.getCategorySales(params);
      const apiData = res?.data ?? res;

      const rows =
        apiData?.table?.content?.map(row => ({
          id: row.categoryId,
          category_name: row.categoryName,
          items: row.items,
          qty_sold: row.qtySold,
          gross_sales: row.grossSales,
          discounts: row.discounts,
          net_sales: row.netSales,
          contribution: row.contribution,
          branchId: row.branchId,
        })) ?? [];

      setData(rows);

      setSummary({
        totalCategories: apiData?.summary?.categories ?? 0,
        totalItems: apiData?.summary?.totalItems ?? 0,
        totalQuantity: apiData?.summary?.quantitySold ?? 0,
        totalNetSales: apiData?.summary?.netSales ?? 0,
      });

      setBranchSummary(apiData?.branchSummary ?? []);
      setTotalItems(apiData?.table?.totalElements ?? 0);
    } catch (err) {
      console.error('useCategorySales ERROR:', err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchCategorySales();
  }, [fetchCategorySales]);

  return {
    data,
    summary,
    branchSummary,
    totalItems,
    loading,
    setFilters,
  };
}
